import { render, staticRenderFns } from "./BankCouponPackage.vue?vue&type=template&id=e033e6c8&scoped=true"
import script from "./BankCouponPackage.vue?vue&type=script&lang=js"
export * from "./BankCouponPackage.vue?vue&type=script&lang=js"
import style0 from "./BankCouponPackage.vue?vue&type=style&index=0&id=e033e6c8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e033e6c8",
  null
  
)

export default component.exports